import { type RouteRecordRaw } from 'vue-router'

export const DashboardAnalyticsRouter: RouteRecordRaw[] = [
  {
    path: '/dashboardAnalytics',
    component: async () => import('./DashboardAnalytics.vue'),
  },
]
